<template>
  <div>
    <div v-if="isLoading === false">
      <base-card v-for="prescription in prescriptions" :key="prescription.id" class="tw-mb-4">
        <business-member-prescription
          :prescription="prescription"
          :user-id="userId"
          :business-id="businessId"
          @updated="loadPrescriptions"
          @show-invite-modal="$refs.inviteToPlanModal.show($event)"
          @show-create-modal="$refs.createPlanModal.show($event)"
        />
      </base-card>
    </div>
    <base-card v-if="isLoading">
      <div class="tw-flex tw-justify-between">
        <div class="tw-flex tw-flex-col tw-flex-grow">
          <base-skeleton-loader class="tw-h-5 tw-w-32 tw-mb-2" />
          <base-skeleton-loader class="tw-h-4 tw-w-1/2" />
        </div>
        <base-icon>
          <more-vertical-icon class="tw-w-6 tw-h-6" />
        </base-icon>
      </div>
      <div class="tw-flex tw-justify-between tw-mt-9">
        <div class="tw-flex-grow tw-pr-4">
          <base-skeleton-loader class="tw-h-8 tw-w-full " />
        </div>
        <div class="tw-flex tw-space-x-4 tw-my-auto">
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full " />
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full" />
        </div>
      </div>
      <div class="tw-flex tw-justify-between tw-mt-8">
        <div class="tw-flex-grow tw-pr-4">
          <base-skeleton-loader class="tw-h-8 tw-w-full " />
        </div>
        <div class="tw-flex tw-space-x-4 tw-my-auto">
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full " />
          <base-skeleton-loader class="tw-h-6 tw-w-6 tw-rounded-full" />
        </div>
      </div>
      <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
      <div class="tw-w-full tw-border-gray-200 tw-border-t tw-mt-4"></div>
      <div class="tw-flex tw-justify-between">
        <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
        <base-skeleton-loader class="tw-h-6 tw-w-24 tw-mt-6" />
      </div>
    </base-card>
    <business-member-prescription-create-plan :business-id="businessId" :user-id="userId" ref="createPlanModal" @updated="goToMemberPlans()" />
    <business-member-prescription-invite-to-plan :business-id="businessId" :user-id="userId" ref="inviteToPlanModal" />
  </div>
</template>

<script>
import BusinessMemberPrescription from "@/views/business/member/prescriptions/components/BusinessMemberPrescription";
import BusinessMemberPrescriptionCreatePlan from "@/views/business/member/prescriptions/components/BusinessMemberPrescriptionCreatePlan";
import BusinessMemberPrescriptionInviteToPlan from "@/views/business/member/prescriptions/components/BusinessMemberPrescriptionInviteToPlan";
import { mapGetters } from "vuex";
import { MoreVerticalIcon } from "@/assets/svgs";

export default {
  components: {
    BusinessMemberPrescription,
    BusinessMemberPrescriptionCreatePlan,
    BusinessMemberPrescriptionInviteToPlan,
    MoreVerticalIcon,
  },
  props: {
    businessId: String,
    userId: String,
    businessPrescriptionId: String,
  },
  data() {
    return {
      isLoading: false,
      prescriptions: [],
    };
  },
  computed: {
    ...mapGetters("organization", ["organization"]),
  },
  created() {
    this.EventBus.$on("prescription-created", this.loadPrescriptions);
    this.loadPrescriptions();
  },
  methods: {
    async loadPrescriptions() {
      try {
        this.isLoading = true;
        const response = await this.$axios.get(`/businesses/${this.organization.id}/members/${this.userId}/prescriptions`);

        if (this.businessPrescriptionId) {
          this.prescriptions = response.data.filter((n) => n.id === this.businessPrescriptionId).sort((a, b) => a.businessProgram.name.localeCompare(b.businessProgram.name));
        } else {
          this.prescriptions = response.data.sort((a, b) => a.businessProgram.name.localeCompare(b.businessProgram.name));
        }
      } finally {
        this.isLoading = false;
      }
    },
    goToMemberPlans() {
      this.loadPrescriptions();
      this.$router.push(`/businesses/${this.organization.id}/members/${this.userId}/plans`);
    },
  },
  watch: {
    userId() {
      this.loadPrescriptions();
    },
  },
};
</script>
